

























































import { Component, Vue } from 'vue-property-decorator';
import {store} from '../_store';
import {ACCOUNT_ACTION} from "@/_store/account";
import { getApiUrl } from '@/_helpers/http';

@Component
export default class Login extends Vue {
    private loading: boolean = false;
    private email: string = '';
    private password: string = '';
    private dirtyEmail?: any;
    private dirtyPwd?: any;
    private emailRules = [
        (v: string) => !!v || 'E-mail is required',
        (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
    ];
    private passwordRules = [
        (v: string) => !!v || 'Password is required',
    ];

    private async login() {
        if ((this.$refs.form as any).validate()) {
            this.loading = true;
            await store.dispatch(ACCOUNT_ACTION.LOGIN, {email: this.email, password: this.password});
            this.loading = false;
        }
    }

    private async created() {
        // Need to figure out how to fix the autocomplete issue
      const url = await getApiUrl();
    }

  get env() {
    return this.$store.getters["api/env"];
  }
}
